var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgIconUsers = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1875 -1279)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M561.5,174a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-2a4,4,0,1,0,4,4,4,4,0,0,0-4-4Zm9,4a4,4,0,0,0-4-4,1,1,0,0,0,0,2,2,2,0,0,1,0,4,1,1,0,0,0,0,2A4,4,0,0,0,570.5,176ZM567,187v-3a3,3,0,0,0-3-3h-5a3,3,0,0,0-3,3v3a1,1,0,0,0,2,0v-3a1,1,0,0,1,1-1h5a1,1,0,0,1,1,1v3a1,1,0,0,0,2,0Zm5,0v-3a3,3,0,0,0-3-3,1,1,0,0,0,0,2,1,1,0,0,1,1,1v3a1,1,0,0,0,2,0Z",
    transform: "translate(1323 1111)"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconUsers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-users.5e760bd3.svg";
export { ForwardRef as ReactComponent };